export default {
    gender: {
        dataTableId: 'gender:name',
        value: [],
    },
    locale: {
        dataTableId: 'locale:name',
        value: [],
    },
    pam_level: {
        dataTableId: 'pam_level:name',
        value: '',
    },
    partner: {
        dataTableId: 'partner:name',
        value: [],
    },
    page: {
        value: 0,
    },
    module_id: {
        dataTableId: 'module_id:name',
        value: [],
    },
    search: {
        dataTableId: 'search',
        value: '',
    },
    stop_on_pregnancy: {
        dataTableId: 'stop_on_pregnancy:name',
        value: '',
    },
};
